const Items = [
  {
    id: 1,
    name: "Prospective Students",
    url: "#",
    hasSubmenu: true,
    bgColor: "",
    subMenuItems: [
      {
        subId: 1,
        name: "Apply Today",
        url: "/prospective/application",
        display: "none",
      },
      {
        subId: 2,
        name: "Request Information",
        url: "/prospective/inquiry",
      },
      {
        subId: 3,
        name: "Admission Test",
        url: "/prospective/admission-test",
        display: "none",
      },
      {
        subId: 4,
        name: "Interview Selection",
        url: "/prospective/interview-selection",
        display: "none",
      },
    ],
  },
  {
    id: 2,
    name: "Students",
    url: "#",
    hasSubmenu: true,
    display: "none",
    bgColor: "",
    subMenuItems: [
      {
        subId: 1,
        name: "Student Dashboard",
        url: "/students/studentdashboard",
      },
      {
        subId: 2,
        name: "Profile",
        url: "/students/profile",
      },
      {
        subId: 3,
        name: "Financial Aid",
        url: "/students/financial-aid",
      },
      {
        subId: 4,
        name: "Degree Plan",
        url: "/students/degree",
      },
      {
        subId: 5,
        name: "Classes",
        url: "/students/classes",
      },
      {
        subId: 6,
        name: "Schedule",
        url: "/students/schedule",
      },
      {
        subId: 7,
        name: "Grades",
        url: "/students/grades",
      },
      {
        subId: 8,
        name: "Select Classes",
        url: "/students/select-class",
      },
      
      // {
      //   subId: 7,
      //   name: "Activity",
      //   url: "#",
      // },
      {
        subId: 8,
        name: "Learning System",
        url: "#",
      },
     
    ],
  },
  {
    id: 3,
    name: "Faculty & Staff",
    url: "#",
    hasSubmenu: true,
    display: "none",
    bgColor: "",
    subMenuItems: [
      {
        subId: 1,
        name: "Profile",
        url: "/faculty/profile",
      },
      {
        subId: 2,
        name: "Classes",
        url: "/faculty/classes",
      },
      {
        subId: 3,
        name: "Enter Attendance",
        url: "/faculty/attendance",
      },

      {
        subId: 4,
        name: "Tests & Scores",
        url: "/faculty/testandscore",
      },
      {
        subId: 5,
        name: "Learning System ",
        url: "#",
      },
      {
        subId: 6,
        name: "Attendance Report",
        url: "/faculty/attendancereport",
      },
    ],
  },
  {
    id: 4,
    name: "Sponsors",
    url: "#",
    hasSubmenu: true,
    display: "none",
    subMenuItems: [
      {
        subId: 1,
        name: "Profile",
        url: "/sponsors/profile",
      },
      {
        subId: 2,
        name: "Attandance",
        url: "/sponsors/attendance",
      },
      {
        subId: 3,
        name: "Grades",
        url: "/sponsors/grades",
      },
    ],
  },
  {
    id: 5,
    name: "Alumni",
    url: "#",
    hasSubmenu: true,
    display: "none",
    subMenuItems: [
      {
        subId: 1,
        name: "My Information",
        url: "/alumni/profile",
      },
      {
        subId: 2,
        name: "Events",
        url: "/alumni/events",
      },
      {
        subId: 3,
        name: "Opportunities",
        url: "/alumni/opportunities",
      },
      {
        subId: 4,
        name: "Donations",
        url: "#",
      },
    ],
  },
  {
    id: 6,
    name: "Events",
    url: "/events",
    hasSubmenu: false,
    display: "none",
    subMenuItems: [],
  },
  {
    id: 7,
    name: "Course Catalog",
    url: "/coursecatalog",
    hasSubmenu: false,
    display: "none",
    subMenuItems: [],
  },
  {
    id: 8,
    name: "Documents",
    url: "/documents",
    hasSubmenu: false,
    display: "none",
    subMenuItems: [],
  },
  {
    id: 9,
    name: "Account",
    url: "/account",
    hasSubmenu: false,
    display: "none",
  },
  {
    id: 10,
    name: "About",
    url: "#",
    hasSubmenu: false,
    display: "none",
    subMenuItems: [],
  }, 
  //  {
  //   id: 11,
  //   name: "StudentDashboard",
  //   url: "/studentdashboard",
  //   hasSubmenu: false,
  //   display: "block",
  // },
];

export default Items;
